import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { query } from '@warp-drive/utilities/json-api';
import type { Store } from '@warp-drive/core';
import type { TasProgramTemplateExtension as TASProgramTemplateModel } from 'tio-data/data/resources/tas-program-template.ext';
import type PartnerService from 'tio-employee/services/partner';

export default class AuthenticatedAdminTuitionAssistanceDashboardRoute extends Route {
  @service declare store: Store;
  @service declare partner: PartnerService;

  async model() {
    const { content } = (await this.store.request(
      query<TASProgramTemplateModel>('tas-program-template', {
        'filter[state]': 'TAS.ProgramTemplateState.LAUNCHED',
        'filter[company]': this.partner.company?.id as string,
        'filter[isTrial]': 'true,false',
      })
    )) as { content: { data: TASProgramTemplateModel[] } };

    return {
      templates: content.data,
    };
  }
}
